import React from 'react';
import { config } from '../../config';
import { OneTrustPolicyWrapper } from './OneTrustPolicyWrapper';

export const TermsOfService = () => <OneTrustPolicyWrapper policyId={config.oneTrustNeonTermsOfServiceId} />
